<template>
  <div>
    <div class="main-balance">
      <Balances />
    </div>
  </div>
</template>

<script>
import Balances from "@/components/Balances";
const moment = require("moment");
export default {
  name: "Balance",
  components: {
    Balances,
  },
  data: function () {
    return {
      curr_balance: null,
      incomes: null,
      admin_balance: null,
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
  },
};
</script>

<style scoped></style>
